import StudyPDF from '../studypdf/StudyPdf.vue' // 引入电子书阅读组件
import ProjectPDF from '../../components/project-pdf/ProjectPDF.vue' // 引入电子书阅读组件
import StudyDiscussion from '../studydiscussion/StudyDiscussion.vue' // 引入讨论主题组件
import CourseAssignments from '../exercise/exercise.vue' // 引入课程作业组件
import TrainingLog from '../../components/training-log/TrainingLog.vue' // 引入研修日志组件
import io from "socket.io-client";

export default {
    data() {
        return {
            // 产品id
            productId: '',
            // 项目id
            projectId: '',
            // 订单项id
            purchasedId: '',
            // 任务索引
            taskIndex: '',
            // 活动索引
            activeIndex: '',
            // 任务id
            taskId: '',
            // 是否可修改答案
            edit: '',
            // 辅导员评分
            grade: '',
            // 辅导员评论
            instructorComment: '',
            // 当前进度
            currProgress: '',
            // 任务详情
            taskInfo: '',
            // 定时器
            timer: null,
            // 订单项数据
            purchasedData: '',
            // 订单项的rate数据
            rate: '',
            // 当前任务名称
            taskName: '',
            // 当前活动
            active: {
                resources: [],
            },
            // 图片前缀
            imgUrl: this.imgUrl,
            // 小图标
            img: {
                time: require("@/assets/images/time.png"),
                user: require("@/assets/images/user.png"),
                tip: require("@/assets/images/tip.png"),
            },
            // 当前章的索引
            chapterIndex: 0,
            // 当前小节的索引
            itemIndex: 0,
            // 当前资源的类型，1是视频，4是电子书阅读，6是主题讨论，7是课程作业/培训心得
            type: 1,
            // 视频对象
            videoObj: null,
            // 课程作业习题限制
            exercise_num: 15,
            // 当前活动的章数组
            chapterList: [],
            // 资源id
            resourceId: '',
            // 观看视频的时间（其他资源的time=1）
            time: 0,
            // 上一次视频进度
            lastProgress: 0,
            // 上一次视频播放时间
            lastTime: 0,
            // 主题讨论完成标志
            discussFlag: 0,
            // 课程作业/培训心得完成标志
            courseworkFlag: 0,
            // WebSocket对象
            ws: null,
            // 研修心得完成标志
            logFlag: 0,
            // pdf完成标志
            pdfFlag: 0,
            // 是否为主动点击
            initiativeToClick:false,
        }
    },

    methods: {

        // 解析方法
        decrypt(data) {
            let CryptoJS = require("crypto-js");
            let bytes = CryptoJS.AES.decrypt(data, '18888888888');
            let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            this.assignedValueByDecryptedData(decryptedData);
        },

        // 根据解密后的数据赋初始值
        assignedValueByDecryptedData(data) {
            // 产品id赋值
            this.productId = data.goodsId;
            // 项目id赋值
            this.projectId = data.project_id;
            // 订单项id赋值
            this.purchasedId = data.purchased_id;
            // 任务索引赋值
            this.taskIndex = Number.parseInt(data.taskState_index);
            // 活动索引赋值
            this.activeIndex = Number.parseInt(data.activeState_index);
            // 任务id赋值
            this.taskId = data.task_id;
            // 是否可修改答案赋值
            this.edit = data.edit;
            // 辅导员评分赋值
            this.grade = data.grade;
            // 辅导员评论赋值
            this.instructorComment = data.instructorComment;
            // 当前进度赋值
            this.currProgress = data.currentProgress;

            // 获取任务详情
            this.getTaskInfo(this.taskId);
        },

        // 获取任务详情
        getTaskInfo(id) {
            this.$post('tasks/get', {
                token: this.$store.state.id,
                id: id,
            }).then(res => {
                this.taskInfo = res.data.result;
            })
        },

        // 获取订单项的数据
        getRate() {
            this.$post('purchased/get', {
                token: this.$store.state.id,
                id: this.purchasedId,
            }).then(res => {
                // 获取订单项数据
                this.purchasedData = res.data.result;
                // 获取rate
                this.rate = JSON.parse(res.data.result.rate);
                // 获取当前任务名称
                this.taskName = this.rate[this.taskIndex].task_name;
                // 获取当前活动
                this.active = this.rate[this.taskIndex].task_activities[this.activeIndex];

                // 获取上一次资源观看进度
                this.getLastProgress();

                // 获取资源
                this.accessToResources();

                // 计算每一小节的进度
                // this.getSectionProgress();
            })
        },

        // 前往课程页面
        toLessonStudy() {
            this.initiativeToClick = true
            this.$router.push({
                path: '/lessonstudy',
                query: {
                    id: this.productId,
                    flag: true
                }
            });
        },

        // 切换章节
        switchChapter(res, index) {
            // console.log(res);
            // console.log(index);

            this.chapterIndex = index;

            // 找出还没有完成的小节资源
            let items = res.items;
            for (let i = 0; i < items.length; i++) {
                if (items[i].state != 2) {
                    this.itemIndex = i;
                    break;
                } else {
                    // 当前章下面的小节全部看完, 小节的索引重置为1
                    this.itemIndex = 0;
                }
            }

            // 获取资源
            this.accessToResources();
        },

        // 创建保利威视视频对象
        videoPlayer(url, time) {
            let currentTime = time ? time : 0;

            // this.videoObj = polyvObject("#plv_1").videoPlayer({
            //     width: '100%',
            //     vid: url,
            //     'flashvars': { "watchStartTime": currentTime, "ban_seek_by_limit_time": "off", 'ban_history_time': 'on' }
            // });

            this.videoObj = polyvObject('#plv_1').videoPlayer({
                width: '100%',
                height: '500',
                'vid': url,
                'forceH5': true,
                // 关闭倍速播放
                speed: false,
                // 进度是否可以拖动、
                // ban_seek_by_limit_time: 'off',
                ban_seek_by_limit_time: 'on',
                // 是否自动播放视频，1自动播放，2不自动播放
                autoplay: 1,
                // 视频默认从第几秒开始播放
                watchStartTime: currentTime,
                // 不记录当前的播放时间，并且不续播
                ban_history_time: 'on',
            });
        },

        // 计算每一小节的进度
        getSectionProgress() {
            let chapterList = [...this.active.resources];

            for (let chapter of chapterList) {

                for (let item of chapter.items) {
                    // 如果当前小节没有进度，则将进度设置为0
                    if (this.$isAbnormal(item.progress)) {
                        item.progress = 0;
                    }
                }
            }
            this.chapterList = chapterList;
        },

        // 获取资源
        accessToResources() {
            // 获取资源id
            let id = this.active.resources[this.chapterIndex].items[this.itemIndex].resources[0];
            if (this.$isAbnormal(id)) {
                alert('暂无资源！即将返回项目主页')
                // 返回项目主页
                this.toLessonStudy();
                return;
            }

            // 获取资源
            this.$post('resources/get', {
                token: this.$store.state.id,
                id: id,
            }).then(res => {
                let resource = res.data.result;
                this.type = resource.type;
                this.resourceId = resource.id;
                let url = resource.data;

                // 当前的小节资源
                let currResource = this.active.resources[this.chapterIndex].items[this.itemIndex];

                // type == 1, 当前资源是视频
                if (this.type == 1) {
                    if (!this.$isAbnormal(currResource.progress)) { // 当前的资源有进度
                        this.lastProgress = currResource.progress;
                    } else {
                        this.lastProgress = 0;
                    }
                    if (!this.$isAbnormal(currResource.currentTime)) { // 当前的资源有已播放时间
                        this.lastTime = currResource.currentTime;
                    } else {
                        this.lastTime = 0;
                    }
                    this.videoPlayer(url, this.lastTime)
                }

                // type == 4, 当前资源是电子书阅读, 点击电子书阅读就将该电子书改为已完成状态
                // if (this.type == 4) {
                //     // 页面渲染好再调用子组件中的方法
                //     this.$nextTick(() => {
                //         // 触发子组件的方法
                //         this.$refs.pdf.getResourse(this.resourceId);

                //         // 保存进度
                //         this.saveTheProgress();
                //     });
                // }

                // type == 4, 当前资源是电子书阅读, 点击调用子组件获取资源的方法
                if (this.type == 4) {
                    // 页面渲染好再调用子组件中的方法
                    this.$nextTick(() => {
                        // 触发子组件的方法
                        this.$refs.pdf.getResourse(this.resourceId);
                    });
                }

                // type == 7, 当前资源是课程作业或培训心得
                if (this.type == 7) {
                    let rule = resource.rule;
                    // 评分规则是2，当前是培训心得，限制输入100字
                    if (rule == 2) {
                        this.exercise_num = 100;
                    }
                }

                // type == 8, 当前资源是研修心得，最少输入20字
                if (this.type == 8) {
                    this.exercise_num = 20;
                }
                // 计算小节进度显示
                let chapterList = [...this.active.resources];
                for (let chapter of chapterList) {

                    for (let item of chapter.items) {
                        // 如果当前小节没有进度，则将进度设置为0
                        if (this.$isAbnormal(item.progress)) {
                            item.progress = 0;
                        }
                    }
                }
                this.chapterList = chapterList;
            })
        },

        // 启动定时器
        setTimer() {
            // console.log('启动定时器了。。。。');
            if (this.timer == null) {
                // 视频观看过程中，每隔300秒保存一次视频
                this.timer = setInterval(() => {
                    // 视频进度等于已观看时长除以视频总时长
                    let progress = this.videoObj.j2s_getCurrentTime() / this.videoObj.j2s_getDuration();
                    // 取两位小数
                    progress = Math.floor(progress * 100) / 100;
                    // console.log('除出来的进度是', progress);
                    // 当前的视频进度大于上次的视频进度才保存
                    if (progress > this.lastProgress) {

                        this.lastProgress = progress;
                        this.lastTime = this.videoObj.j2s_getCurrentTime();

                        // console.log('this.chapterIndex', this.chapterIndex);
                        // console.log('this.itemIndex', this.itemIndex);

                        // 重新赋值
                        this.active.resources[this.chapterIndex].items[this.itemIndex].progress = this.lastProgress;
                        this.active.resources[this.chapterIndex].items[this.itemIndex].currentTime = this.currentTime;

                        // 计算小节进度给前端显示
                        this.getSectionProgress();

                        if (this.type == 1) {
                            // 保存进度
                            this.saveTheProgress();

                            this.setTimer();
                        }
                    }
                }, 300000);
            }
        },

        // 保存进度
        // 视频播放完毕调用该方法时，传入true
        async saveTheProgress(flag) {
            // 关闭定时器
            clearInterval(this.timer);
            this.timer = null;

            // 计算进度
            let { progress, time } = this.calculateProgressOnSave(flag);

            // console.log('现在保存时的progress === ', progress);
            // console.log('现在保存时的time === ', time);

            // 给当前小节进度赋值
            this.assignmentBySection(progress, time);

            // 给当前章进度赋值
            this.assignmentByChapter(this.active.resources[this.chapterIndex].items);

            // 给当前活动进度赋值
            this.assignmentByActive(this.active);

            // 判断当前任务是否已经完成
            this.assignmentByTask();

            // 将活动数组替换为最新的
            this.$set(this.rate[this.taskIndex].task_activities, this.activeIndex, this.active);


            // console.log('视频看完的活动的章数组是 == ', this.active.resources);

            // console.log('this.rate = ', JSON.stringify(this.rate));
            // console.log('this.active = ', JSON.stringify(this.active));

            let endTime = '';
            let endProgress = this.calculateProjectProgress();
            // 如果进来学习页面时项目的总进度不等于1，保存时项目的学习进度为1，则为项目添加结束学习时间
            if (this.currProgress != 1 && endProgress == 1) {
                let res = await this.getNetworkTime();
                endTime = res.data.result.updated_at;
            }


            // 发送请求，保存进度
            await this.$post('purchased/sumbitRate', {
                token: this.$store.state.id,
                id: this.purchasedId,
                rate: JSON.stringify(this.rate),
                progress: endProgress,
                end_time: endTime,
            }).then(() => {
                this.$post('purchased/get', {
                    token: this.$store.state.id,
                    id: this.purchasedId,
                }).then(res => {
                    // 获取rate
                    this.rate = JSON.parse(res.data.result.rate);

                    // 获取当前活动
                    this.active.resources = [...this.rate[this.taskIndex].task_activities[this.activeIndex].resources];

                    // console.log('保存进度后重新获取的活动为  ', JSON.stringify(this.active.resources));
                })
            })

            // console.log('我第一,保存好了');
        },

        // 计算进度，返回某个小节的进度progress和时间time对象
        calculateProgressOnSave(flag) {
            let progress = 0; // 进度
            let time = 0; // 已观看时长

            // 如果当前资源时视频、电子书阅读或课程作业
            if (this.type == 1 || this.type == 6 || this.type == 7 || this.type == 4 || this.type == 8) {

                // 能进来，证明当前的视频已经播放完毕了
                if (flag && this.type == 1) {
                    progress = 1;
                    time = this.videoObj.j2s_getDuration();
                } else {

                    // 当前资源是视频
                    if (this.type == 1) {
                        // 进度等于视频已看的时长除以视频总时长，取2位小数
                        let currentTime = this.videoObj.j2s_getCurrentTime();
                        let duration = this.videoObj.j2s_getDuration();
                        if (!currentTime) {
                            currentTime = 0;
                        }
                        if (!duration) {
                            duration = 0;
                        }
                        if (currentTime === 0 || duration === 0) {
                            progress = 0;
                        } else {
                            progress = Math.floor((currentTime / duration) * 100) / 100;
                        }

                        time = this.videoObj.j2s_getCurrentTime();

                        // 如果进度没有大于看之前的进度，就按之前的进度存
                        if (progress * 1 <= this.lastProgress * 1) {
                            progress = this.lastProgress;
                            time = this.lastTime;
                        }
                    } else if (this.type == 6 && this.discussFlag == 2) { // 当前资源是主题讨论且已经完成
                        progress = 1;
                        time = 1;
                        this.discussFlag = 0;
                    } else if (this.type == 7 && this.courseworkFlag == 2) { // 当前资源是课程作业/培训心得且已经完成
                        progress = 1;
                        time = 1;
                        this.courseworkFlag = 0;
                    } else if (this.type == 8 && this.logFlag == 2) { // 当前资源是研修心得且已经完成
                        progress = 1;
                        time = 1;
                        this.logFlag = 0;
                    } else if (this.type == 4 && this.pdfFlag == 2) { // 当前资源是电子书阅读且已经完成
                        progress = 1;
                        time = 1;
                        this.pdfFlag == 0;
                    }
                }

            }

            return {
                'progress': progress,
                'time': time,
            }
        },

        // 给当前小节进度赋值
        assignmentBySection(progress, time) {
            if (progress == 1) {
                this.active.resources[this.chapterIndex].items[this.itemIndex].progress = 1;
                this.active.resources[this.chapterIndex].items[this.itemIndex].currentTime = time;
                this.active.resources[this.chapterIndex].items[this.itemIndex].state = 2;
            } else {
                this.active.resources[this.chapterIndex].items[this.itemIndex].progress = Number.parseFloat(progress).toFixed(2);
                this.active.resources[this.chapterIndex].items[this.itemIndex].currentTime = time;
                this.active.resources[this.chapterIndex].items[this.itemIndex].state = 1;
            }

            // console.log('当前小节赋值后 =  ', this.active.resources[this.chapterIndex].items[this.itemIndex]);

            // 计算小节进度给前端显示
            this.getSectionProgress();
        },

        // 给当前章进度赋值
        assignmentByChapter(items) {
            // 计算当前章里面的小节是否全部完成，小节全部完成，当前章就完成
            let flag = true;
            for (let item of items) {
                if (item.state != 2) {
                    flag = false;
                    break;
                }
            }

            if (flag) {
                this.$set(this.active.resources[this.chapterIndex], 'state', 2);
            } else {
                this.$set(this.active.resources[this.chapterIndex], 'state', 1);
            }
        },

        // 给当前活动进度赋值
        assignmentByActive(active) {
            // 计算当前活动里面的章是否全部完成，章全部完成，当前活动就完成
            let flag = true;
            for (let chapter of active.resources) {

                if (chapter.state != 2) {
                    flag = false;
                    break;
                }
            }

            if (flag) {
                this.$set(this.active, 'activeState', 2);
            } else {
                this.$set(this.active, 'activeState', 1);
            }
        },

        // 给当前任务进行赋值
        async assignmentByTask() {
            // 当前任务里面的所有活动是否已完成，全部活动完成，当前任务完成
            let flag = true;

            for (let active of this.rate[this.taskIndex].task_activities) {
                if (active.activeState != 2) {
                    flag = false;
                    break;
                }
            }

            if (flag) {
                this.$set(this.rate[this.taskIndex], 'taskState', 2);

                // 当前任务完成，没有完成时间则添加完成时间
                if (this.$isAbnormal(this.rate[this.taskIndex].updated_at)) {
                    // console.log('当前任务已经完成');
                    let res = await this.getNetworkTime();
                    let updated_at = res.data.result.updated_at;
                    // let updated_at = new Date(+new Date() + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
                    this.$set(this.rate[this.taskIndex], 'updated_at', updated_at);
                }
            } else {
                this.$set(this.rate[this.taskIndex], 'taskState', 1);
            }
        },

        // 选择小节资源
        switchItem(item, itemIndex) {
            // 将点击的资源的index赋值给itemIndex
            this.itemIndex = itemIndex;

            // 获取资源
            this.accessToResources();

            // // console.log('点击选择小节资源时上一个的活动是', JSON.stringify(this.active.resources));
            // // console.log('上一个资源的state是 ', this.active.resources[this.chapterIndex].items[this.itemIndex].state);
            // // 获取上一个资源的state
            // let state = this.active.resources[this.chapterIndex].items[this.itemIndex].state;
            //
            // // 如果state == 2，就证明该资源是已经学习完成的
            // if (state == 2) {
            //     // 先保存上次的进度
            //     this.saveTheProgress(true).then(() => {
            //
            //         // 将点击的资源的index赋值给itemIndex
            //         this.itemIndex = itemIndex;
            //
            //         // 获取资源
            //         this.accessToResources();
            //
            //         // 计算小节进度给前端显示
            //         this.getSectionProgress();
            //     });
            // } else {
            //     // 先保存上次的进度
            //     this.saveTheProgress().then(() => {
            //
            //         // 将点击的资源的index赋值给itemIndex
            //         this.itemIndex = itemIndex;
            //
            //         // 获取资源
            //         this.accessToResources();
            //
            //         // 计算小节进度给前端显示
            //         this.getSectionProgress();
            //     });
            // }
        },

        // 获取上一次资源观看进度
        getLastProgress() {
            let chapterIndex = 0;
            let itemIndex = 0;

            outer:
            for (let i = 0; i < this.active.resources.length; i++) {

                for (let j = 0; j < this.active.resources[i].items.length; j++) {
                    // 如果当前小节的state不等于2，就用i赋值给章索引，j赋值给小节索引
                    if (this.active.resources[i].items[j].state != 2) {
                        chapterIndex = i;
                        itemIndex = j;
                        break outer;
                    }
                }
            }

            this.chapterIndex = chapterIndex;
            this.itemIndex = itemIndex;
        },

        // 计算项目进度
        calculateProjectProgress() {
            let index1 = 0;
            for (let i = 0; i < this.rate.length; i++) {
                if (this.rate[i].taskState == 2) {
                    index1 += 1;
                } else {
                    let index2 = 0
                    for (let j = 0; j < this.rate[i].task_activities.length; j++) {
                        if (this.rate[i].task_activities[j].activeState == 2) {
                            index2 += 1;
                        } else {
                            let index3 = 0;
                            let length2 = 0;
                            for (let z = 0; z < this.rate[i].task_activities[j].resources.length; z++) {
                                length2 += this.rate[i].task_activities[j].resources[z].items.length;
                                for (let y = 0; y < this.rate[i].task_activities[j].resources[z].items.length; y++) {
                                    if (this.rate[i].task_activities[j].resources[z].items[y].progress == 1) {
                                        index3 += 1;
                                    }
                                }
                            }
                            index2 += index3 / length2;
                        }
                    }
                    index1 += index2 / this.rate[i].task_activities.length;
                }
            }
            // console.log('当前项目进度 = ', index1 / this.rate.length);
            return index1 / this.rate.length;
        },

        // 保存主题讨论进度，由子组件触发
        saveDiscussionProgress(val) {
            this.discussFlag = val;
            this.saveTheProgress();
        },

        // 保存课程作业的进度, 由子组件触发
        saveCourseAssignmentsProgress(val) {
            this.courseworkFlag = val;
            this.saveTheProgress();
        },

        // 保存研修作业的进度，由子组件触发
        saveLogProgress(val) {
            this.logFlag = val;
            this.saveTheProgress();
        },

        // 保存pdf进度，由子组件触发
        savePDFProgress(val) {
            this.pdfFlag = val;
            this.saveTheProgress();
        },

        // 获取时间
        getNetworkTime() {
            return this.$get('getDateTime');
        },
    },

    created() {
        // 解析地址栏的数据
        this.decrypt(this.$route.query.data);

        // 进入该页面时，先清除定时器
        clearInterval(this.timer);

        // 关闭窗口监听事件
        window.onbeforeunload = () => {
            // 关闭窗口时断开WebSocket连接
            this.ws.close();
        }
    },

    // 这里主要用来判断是否同时学习
    mounted() {
        let me = this;

        if ('WebSocket' in window) {
            // 获取当前登录的用户id
            let id = me.$store.state.userId;
            this.ws = io("wss://teach-websocket.ca163.com?id=" + id + 'project');
            // let ws = new WebSocket("wss://runqin-socket.bayou-tech.cn/websocket?id=" + id + '&policy=2');
            
            this.ws.on('connect', () => {
                console.log('socket已连接...');
                
            });
            
            this.ws.on('disconnect', () => {
                console.log('断开了')
                // socket断开连接，
                // 学员在同时学习，提示后返回课程页面
                this.$router.push({
                    path: '/lessonstudy',
                    query: {
                        id: this.productId,
                        flag: true,
                        type: 'show',
                        initiativeToClick:this.initiativeToClick
                    }
                })
                // this.$alert('请不要同时学习', '提示', {
                //     confirmButtonText: '确定',
                //     callback: () => {
                //         this.$router.push({
                //             path: '/lessonstudy',
                //             query: {
                //                 id: this.productId,
                //                 flag: true,
                //             }
                //         })
                //     }
                // })
            });
            
            // 获取当前订单项的rate
            me.getRate();
            
            // 视频播放完毕触发函数
            window.s2j_onPlayOver = () => {
                // 清除定时器
                clearInterval(this.timer);
                this.timer = null;
            
                // 保存进度
                this.saveTheProgress(true);
            }
            
            // 视频播放时触发函数
            window.s2j_onVideoPlay = () => {
                // 启动定时器
                me.setTimer();
            }
            
            // 视频暂停时触发函数
            window.s2j_onVideoPause = () => {
                // 清除定时器
                clearInterval(this.timer);
                this.timer = null;
                // 保存进度
                this.saveTheProgress();
            }

            // ws.onmessage = (evt) => {

            //     if (JSON.parse(evt.data).success === 'true') {
            //         // 获取当前订单项的rate
            //         me.getRate();

            //         // 视频播放完毕触发函数
            //         window.s2j_onPlayOver = () => {
            //             // 清除定时器
            //             clearInterval(this.timer);
            //             this.timer = null;

            //             // 保存进度
            //             this.saveTheProgress(true);
            //         }

            //         // 视频播放时触发函数
            //         window.s2j_onVideoPlay = () => {
            //             // 启动定时器
            //             me.setTimer();
            //         }

            //         // 视频暂停时触发函数
            //         window.s2j_onVideoPause = () => {
            //             // 清除定时器
            //             clearInterval(this.timer);
            //             this.timer = null;
            //             // 保存进度
            //             this.saveTheProgress();
            //         }

            //     } else {
            //         // 学员在同时学习，提示后返回课程页面
            //         this.$alert('请不要同时学习', '提示', {
            //             confirmButtonText: '确定',
            //             callback: () => {
            //                 this.$router.push({
            //                     path: '/lessonstudy',
            //                     query: {
            //                         id: this.productId,
            //                         flag: true,
            //                     }
            //                 })
            //             }
            //         })
            //     }

            // }

        }
    },

    components: {
        StudyPDF,
        StudyDiscussion,
        CourseAssignments,
        TrainingLog,
        ProjectPDF
    },

    // 离开视频页面时关闭WebSocket连接
    beforeRouteLeave(to, from, next) {
        this.ws.close();
        next();
    },
}
